import React, { useContext, useEffect, useState } from "react";
import styles from "./Step.module.css";
import StepsHeader from "../../../Components/StepsHeader/StepsHeader";
import Hot from "../../../assets/componentAssets/Hot.svg";
import info from "../../../assets/componentAssets/info.svg";
import {
  Button,
  FormControl,
  FormHelperText,
  InputAdornment,
  MenuItem,
  Select,
  TextField,
} from "@mui/material";
import DateField from "../../../Components/DateField/DateField";
import NavButton from "./NavButton";
import { AppContext } from "../../../ContextApi/AppContext/AppContext";
import { PatchApi, getApi } from "../../../Utility/network";
import { monthYear } from "../utility/utils";
import { selectedLanguage, zdate } from "../../../Utility/helper";
import PopUpInfo from "../../../Components/PopUpInfo/PopUpInfo";
import { errorMessage } from "../../../Utility/constants";
import { germanMonths } from "../../Need/utility/utils";
import { convertCommaToDot, convertDotToComma } from "../../../Utility/utils";

function Step3() {
  const { state, setState, HandleErrorPop, openPop } = useContext(AppContext);
  const { stepLanguage, language } = state;
  const [hotWater, setHotWater] = useState([]);
  const [response, setResponse] = useState(false);
  const [unit, setUnit] = useState(Array.from({ length: 4 }, () => []));
  const [energy, setEnergy] = useState({ source: [], unit: [] });
  const [show, setShow] = useState(1);
  const [errors, setErrors] = useState([]);
  const [disableNext, setDisableNext] = useState(true);

  const [form, setForm] = useState({
    Date: new Date(),
  });
  const [pop, setPop] = useState(false);
  const [infoText, setInfoText] = useState([]);
  useEffect(() => {
    getData();
    window.scroll(0, 0);
  }, []);
  useEffect(() => {
    setTimeout(() => {
      setDisableNext(false);
    }, 3000);
  });
  const getData = async () => {
    try {
      const source = await getApi(`/energy_consumption/energy_source`);
      const unit = await getApi(`/energy_consumption/energy_source_units`);
      setEnergy({ source: source.data.data, unit: unit.data.data });
    } catch (error) {}
  };

  const handleSubmit = async (num, type) => {
    const updatedHeatingInfo = hotWater.map((info) => {
      if (info.hasOwnProperty("hot_water_data")) {
        // hot_water_data exists, proceed with the transformation
        return {
          ...info,
          hot_water_data: {
            ...info.hot_water_data,
            consumption_info: info.hot_water_data.consumption_info.map(
              (item) => ({
                ...item,
                date: zdate(item.date), // Update the date format
              })
            ),
          },
        };
      } else {
        // hot_water_data doesn't exist, return the original info
        return info;
      }
    });
    try {
      if (type === "next") {
        const errors = validateHeatingInfoArray(updatedHeatingInfo);
        const checkError = isAllFieldsEmpty(errors);
        setErrors(errors);

        if (!checkError) return;
        try {
          let newUpdatedHeatingInfo = updatedHeatingInfo.map((item, index) => {
            return {
              ...item,
              percentage: convertCommaToDot(item.percentage.toString()),
            };
          });
          const postData = await PatchApi(
            `/energy_consumption/form/${state.form_id}/`,
            {
              heating_info: newUpdatedHeatingInfo,
              language: language === "de" ? 2 : 1,
            }
          );
          if (postData.status === 200 || postData.status === 201) {
            setState((prev) => ({
              ...prev,
              page: 4,
              filledPage: prev.filledPage >= 4 ? prev.filledPage : 4,
              otherData: {
                ...prev.otherData,
                yearArray: newUpdatedHeatingInfo,
              },
            }));
          } else {
            throw Error("api failed");
          }
        } catch (error) {
          alert(error);
        }
      } else if (type === "prev") {
        setState((prev) => ({ ...prev, page: prev.page - 1 }));
      } else if (type === "save") {
        await getApi(`/energy_consumption/form/${state.form_id}/generate_link`);
        setResponse(true);
        // navigate("/login");
      }
    } catch (error) {
      HandleErrorPop(true);
    }
  };

  useEffect(() => {
    // const arr = [];
    // const numberOfElements =
    //   state.otherData.hotwater_included_in_heating_system; // Assuming this is a number

    // // Initialize a new array of the desired length and fill it with a placeholder value (like null)
    // const waterObject = Array.from({ length: numberOfElements }).map(
    //   (_, index) => {
    //     arr.push(obj); // Add the object to `arr`
    //     return obj; // Return the object to the new array
    //   }
    // );

    if (state.otherData && state.otherData.yearArray) {
      state.otherData.yearArray.forEach((item, index) => {
        if (energy.source.length > 0) {
          if (item.hot_water_data) {
            let newIndex = energy.source.findIndex(
              (obj) => item.hot_water_data.energy_source_id === obj.id
            );
            unit[index] = energy.source[newIndex].unit;

            setUnit((prev) => [...unit]);
          }
        }
      });
      const newArr = state?.otherData?.yearArray?.map((item, index) => {
        return {
          ...item,
          type: item.type ? item.type : 1,
          percentage:
            language === "de"
              ? convertDotToComma(item.percentage.toString()).toString()
              : convertCommaToDot(item.percentage.toString()).toString(),
        };
      });
      setHotWater(newArr);
    }
  }, [state.otherData.yearArray, energy]);
  const handleClick = (_type, pos) => {
    const newArr = hotWater?.map((item, index) => {
      if (pos == index) {
        if (_type === 1) {
          const { hot_water_data, ...rest } = item; // Destructure to omit hot_water_data
          return {
            ...rest,
            type: _type,
            hotwater_included_in_heating_system: _type,
          };
        } else {
          let newData = [...item.consumption_info];
          const _data = newData.map((itm, idx) => {
            return { ...itm, consumption: "" };
          });
          return {
            ...item,
            type: 1,
            hotwater_included_in_heating_system: 2,
            hot_water_data: {
              ...item.hot_water_data, // Preserve the existing hot_water_data
              consumption_info: _data, // Update consumption_info with _data
              energy_source_id: null,
              index: 1,
              unit_id: null,
              type: 2, // Update other properties as needed
            },
          };
        }
      } else {
        return item;
      }
    });
    setHotWater(newArr);
  };
  const options = [];
  const style = { width: "100%" };
  const handleChange = (e, index, _type) => {
    // setData(prev=>({...prev,heating_info:}))
    const { value, name } = e.target; // Get the input value
    setHotWater((prevData) => {
      // Make a copy of the previous state
      const newData = [...prevData];
      // Update the specific field of the object at the given index
      newData[index].hot_water_data[name] = value;
      return newData; // Return the updated array
    });
  };
  const handleChange1 = (e, index, index1) => {
    const { value, name } = e.target; // Get the input value
    const cleanedValue = value.replace(/[,.]/g, "");

    setHotWater((prevData) => {
      const newData = [...prevData];
      // Directly access the nested object property and update it
      newData[index].hot_water_data.consumption_info[index1].consumption =
        cleanedValue;
      // console.log(newData, "hello data");
      return newData;
    });
  };
  const handleChangeIn = (e, index) => {
    const { name, value } = e.target;
    // if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
    setHotWater((prevData) => {
      // Make a copy of the previous state
      const newData = [...prevData];
      // Update the specific field of the object at the given index
      newData[index] = { ...newData[index], [name]: value };
      return newData; // Return the updated array
    });
    // }
  };

  const handlePopUp = (data) => {
    setPop(true);
    setInfoText(data);
  };
  const handleDate = () => {};

  const validateHeatingInfoArray = (heatingInfoArray) => {
    let newHeatingArray = JSON.stringify(heatingInfoArray);
    newHeatingArray = JSON.parse(newHeatingArray);
    // Initialize errors array
    const errors = newHeatingArray.map(() => ({
      energy_source_id: "",
      unit_id: "",
      type: "",
      installation_year: "",
      hotwater_included_in_heating_system: "",
      percentage: "",
      consumption_info: [],
      hot_water_data: {
        energy_source_id: "",
        unit_id: "",
        type: "",
        installation_year: "",
        hotwater_included_in_heating_system: "",
        percentage: "",
        consumption_info: [],
      },
    }));

    heatingInfoArray.forEach((heatingInfo, heatingIndex) => {
      const heatingErrors = errors[heatingIndex];
      // Validate energy_source_id
      if (heatingInfo.energy_source_id === null) {
        heatingErrors.energy_source_id = `${stepLanguage.energy_required}`;
      }

      // Validate unit_id
      if (heatingInfo.unit_id === null) {
        heatingErrors.unit_id = `${stepLanguage.unitId_required}`;
      }

      // Uncomment and use these validation checks as needed
      /*
      // Validate type
      if (typeof heatingInfo.type !== "number" || heatingInfo.type <= 0) {
        heatingErrors.type = "Type must be a positive number.";
      }
  
      // Validate installation_year
      if (
        typeof heatingInfo.installation_year !== "number" ||
        heatingInfo.installation_year <= 0
      ) {
        heatingErrors.installation_year =
          "Installation year must be a positive number.";
      }
  
      // Validate hotwater_included_in_heating_system
      if (![0, 1].includes(heatingInfo.hotwater_included_in_heating_system)) {
        heatingErrors.hotwater_included_in_heating_system =
          "Hot water included in heating system must be either 0 (no) or 1 (yes).";
      }
  
     
      */
      // Validate percentage

      if (heatingInfo.hasOwnProperty("hot_water_data")) {
        if (heatingInfo.hot_water_data.energy_source_id === null) {
          heatingErrors.hot_water_data.energy_source_id = `${stepLanguage.energy_required}`;
        }

        // Validate unit_id
        if (heatingInfo.hot_water_data.unit_id === null) {
          heatingErrors.hot_water_data.unit_id = `${stepLanguage.unitId_required}`;
        }
        if (
          !Array.isArray(heatingInfo.hot_water_data.consumption_info) ||
          heatingInfo.hot_water_data.consumption_info.length === 0
        ) {
          heatingErrors.hot_water_data.consumption_info.push(
            `${stepLanguage.con_info}`
          );
        } else {
          heatingInfo.hot_water_data.consumption_info.forEach((info, idx) => {
            const consumptionErrors =
              heatingErrors.hot_water_data.consumption_info[idx] || {};
            // Check if the consumption value is invalid
            if (
              info.consumption === "" ||
              info.consumption === null ||
              isNaN(info.consumption) ||
              /[-eE+]/.test(info.consumption)
            ) {
              consumptionErrors.consumption = `${stepLanguage.invalid_consum}`;
            }

            if (idx === 1 || idx === 2) {
              const baseConsumption = parseFloat(
                heatingInfo.hot_water_data.consumption_info[0].consumption
              );
              const currentConsumption = parseFloat(info.consumption);

              // if (
              //   !isNaN(baseConsumption) &&
              //   !isNaN(currentConsumption)
              // ) {
              //   const minLimit = 0.25 * baseConsumption; // 25% of value at index 0
              //   const maxLimit = 1.75 * baseConsumption; // 75% of value at index 0

              //   if (
              //     currentConsumption < minLimit ||
              //     currentConsumption > maxLimit
              //   ) {
              //     consumptionErrors.consumption = `Value should not be less than 25% or greater than 175% of  ${heatingInfo.consumption_info[0].consumption} i.e the value in first consumption field.`;
              //   }
              // }
            }

            // Add the error object to consumption_info errors array
            if (Object.keys(consumptionErrors).length > 0) {
              heatingErrors.hot_water_data.consumption_info[idx] =
                consumptionErrors;
            }
          });
        }
      } else {
        if (language === "de") {
          const regex = /^[0-9]+(,[0-9]+)?$/; // Matches numbers with an optional comma for decimals
          let newVac = heatingInfo.percentage.toString();
          newVac = convertCommaToDot(newVac.toString()); // Convert comma to dot for further validation

          if (
            typeof newVac !== "string" || // Ensure input is a string
            !regex.test(heatingInfo.percentage) || // Validate format: digits, optional comma
            parseFloat(newVac) < 0 || // Check range: >= 0
            parseFloat(newVac) > 100 // Check range: <= 100
          ) {
            heatingErrors.percentage = `${stepLanguage.per_pos}`; // Set error message
          }
        } else {
          const newVac = heatingInfo.percentage.toString(); // Convert comma to dot for further validation

          if (
            typeof newVac !== "string" || // Ensure input is a string
            !/^\d+(\.\d+)?$/.test(newVac) || // Regex to validate numbers and decimals
            parseFloat(newVac) < 0 || // Check range: >= 0
            parseFloat(newVac) > 100 // Check range: <= 100
          ) {
            heatingErrors.percentage = `${stepLanguage.per_pos}`; // Set error message
          }
        }

        // if (heatingInfo.percentage == null || heatingInfo.percentage == "") {
        //   heatingErrors.percentage = `${stepLanguage.per_pos}`;
        // }
      }
      // Validate consumption_info array
      if (
        !Array.isArray(heatingInfo.consumption_info) ||
        heatingInfo.consumption_info.length === 0
      ) {
        heatingErrors.consumption_info.push(`${stepLanguage.con_info}`);
      } else {
        heatingInfo.consumption_info.forEach((info, idx) => {
          const consumptionErrors = heatingErrors.consumption_info[idx] || {};
          // Check if the consumption value is invalid
          if (
            info.consumption === "" ||
            info.consumption === null ||
            isNaN(info.consumption) ||
            /[-eE+]/.test(info.consumption)
          ) {
            consumptionErrors.consumption = `${stepLanguage.invalid_consum}`;
          }

          if (idx === 1 || idx === 2) {
            const baseConsumption = parseFloat(
              heatingInfo.consumption_info[0].consumption
            );
            const currentConsumption = parseFloat(info.consumption);

            // if (
            //   !isNaN(baseConsumption) &&
            //   !isNaN(currentConsumption)
            // ) {
            //   const minLimit = 0.25 * baseConsumption; // 25% of value at index 0
            //   const maxLimit = 1.75 * baseConsumption; // 75% of value at index 0

            //   if (
            //     currentConsumption < minLimit ||
            //     currentConsumption > maxLimit
            //   ) {
            //     consumptionErrors.consumption = `${stepLanguage.less_great}  ${heatingInfo.consumption_info[0].consumption} ${stepLanguage.i_e}`;
            //   }
            // }
          }

          // Add the error object to consumption_info errors array
          if (Object.keys(consumptionErrors).length > 0) {
            heatingErrors.consumption_info[idx] = consumptionErrors;
          }
        });
      }
    });
    return errors;
  };
  const popData = {
    Energy_Sources: [
      {
        heading: stepLanguage.Energy_h,
        para1: stepLanguage.Energy_d,
      },
    ],
    Unit: [
      {
        heading: stepLanguage.unit_h,
        para1: stepLanguage.unit_d1,
        para2: stepLanguage.unit_d2,
      },
    ],
    date: [
      {
        heading: stepLanguage.date,
        para1: stepLanguage.date_d,
      },
    ],
    date2: [
      {
        heading: stepLanguage.date,
        para1: stepLanguage.date_d2,
      },
    ],
    date3: [
      {
        heading: stepLanguage.date,
        para1: stepLanguage.date_d3,
      },
    ],
    date4: [
      {
        heading: stepLanguage.date,
        para1: stepLanguage.date_d4,
      },
    ],
    consumption: [
      {
        heading: stepLanguage.consmCount_h,
        para1: stepLanguage.consmCount_d1,
        para2: stepLanguage.consmCount_d2,
        para3: stepLanguage.consmCount_d3,
      },
    ],
    included: [
      {
        heading: stepLanguage.include_h,
        para1: stepLanguage.include_d,
      },
    ],
    stystem: [
      {
        heading: stepLanguage.system_h,
        para1: stepLanguage.system_d,
      },
    ],
  };
  return (
    <div>
      <div className={styles.con}>
        <StepsHeader
          image={Hot}
          heading={state?.headerLanguage?.heat_water_info}
          secPara={stepLanguage.Please_provide_proper_information}
        />
        <div className={styles.fieldDetails}>
          {/* {show === 1 && (
            <div className={styles.fields}>
              <p className={styles.fieldName}>
                Percentage share of hot water
                <img src={info} />
              </p>
              <TextField
                size="small"
                style={style}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">%</InputAdornment>
                  ),
                }}
              />
            </div>
          )} */}
          {hotWater.map((item, index) => {
            let _unit = unit.length < index + 1 ? unit : unit[index];
            let suffix = _unit.findIndex((obj, i) => obj.id === item.unit_id);
            let text = _unit[suffix] ? _unit[suffix].title : "";
            let energySourceError =
              errors[index]?.hot_water_data.energy_source_id;
            let energyUnitError = errors[index]?.hot_water_data.unit_id;
            let percentageError = errors[index]?.percentage;

            return (
              <div key={index}>
                <div className={styles.fields}>
                  <p className={styles.fieldName}>
                    {stepLanguage.included_heating_system} ({index + 1})
                    <img
                      src={info}
                      style={{ cursor: "pointer" }}
                      onClick={() => handlePopUp(popData?.included)}
                    />
                  </p>
                  <div className={styles.num}>
                    <Button
                      variant={`${
                        !item.hasOwnProperty("hot_water_data")
                          ? "contained"
                          : "outlined"
                      }`}
                      onClick={() => {
                        handleClick(1, index);
                      }}
                    >
                      {stepLanguage.yes}
                    </Button>
                    <Button
                      variant={`${
                        item.hasOwnProperty("hot_water_data")
                          ? "contained"
                          : "outlined"
                      }`}
                      onClick={() => {
                        handleClick(2, index);
                      }}
                    >
                      {stepLanguage.no}
                    </Button>
                    <Button
                      variant={`${item.type === 3 ? "contained" : "outlined"}`}
                      onClick={() => handleClick(3, index)}
                      disabled={true}
                    >
                      {stepLanguage.consumption_is_unknown}
                    </Button>
                  </div>
                </div>
                {!item.hasOwnProperty("hot_water_data") && (
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      {stepLanguage.percentage_share_of_hot_water}
                      <img
                        src={info}
                        style={{ cursor: "pointer" }}
                        onClick={() => handlePopUp(popData?.stystem)}
                      />
                    </p>
                    <TextField
                      size="small"
                      style={style}
                      onChange={(e) => handleChangeIn(e, index)}
                      name="percentage"
                      value={item.percentage}
                      onWheel={(e) => e.target.blur()}
                      InputProps={{
                        endAdornment: (
                          <InputAdornment position="end">%</InputAdornment>
                        ),
                      }}
                      error={percentageError}
                      helperText={percentageError}
                    />
                  </div>
                )}
                {item.hasOwnProperty("hot_water_data") && (
                  <div>
                    <div className={styles.fieldCom}>
                      <div className={styles.fields}>
                        <p className={styles.fieldName}>
                          {stepLanguage.energy_sources}
                          <img
                            src={info}
                            style={{ cursor: "pointer" }}
                            onClick={() => handlePopUp(popData?.Energy_Sources)}
                          />
                        </p>
                        <FormControl
                          fullWidth
                          error={Boolean(energySourceError)}
                        >
                          <Select
                            style={style}
                            size="small"
                            onChange={(e) => {
                              handleChange(e, index, "inner");
                              let newIndex = energy.source.findIndex(
                                (obj) => e.target.value === obj.id
                              );
                              unit[index] = energy.source[newIndex].unit;
                              setUnit((prev) => [...unit]);
                            }}
                            value={
                              item?.hot_water_data
                                ? item?.hot_water_data?.energy_source_id
                                : ""
                            }
                            name="energy_source_id"
                          >
                            {energy.source.map((option) => (
                              <MenuItem key={option.id} value={option.id}>
                                {/* {option.title} */}
                                {selectedLanguage(option, language)}
                              </MenuItem>
                            ))}
                          </Select>
                          {energySourceError && (
                            <FormHelperText
                              id={`energySourceError-${index}`}
                              style={{ color: `${errorMessage}` }}
                            >
                              {energySourceError}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>

                      <div className={styles.fields}>
                        <p className={styles.fieldName}>
                          {stepLanguage.unit}
                          <img
                            src={info}
                            style={{ cursor: "pointer" }}
                            onClick={() => handlePopUp(popData?.Unit)}
                          />
                        </p>
                        <FormControl
                          fullWidth
                          error={Boolean(energySourceError)}
                        >
                          <Select
                            style={style}
                            size="small"
                            onChange={(e) => handleChange(e, index, "inner")}
                            name="unit_id"
                            value={
                              item?.hot_water_data
                                ? item?.hot_water_data?.unit_id
                                : _unit.length > 0
                                ? _unit[0]
                                : ""
                            }
                          >
                            {_unit.map((option) => (
                              <MenuItem
                                key={`${index}` + option.id}
                                value={option.id}
                              >
                                {selectedLanguage(option, language)}
                                {/* {option.title} */}
                              </MenuItem>
                            ))}
                          </Select>
                          {energyUnitError && (
                            <FormHelperText
                              id={`energyUnitError-${index}`}
                              style={{ color: `${errorMessage}` }}
                            >
                              {energyUnitError}
                            </FormHelperText>
                          )}
                        </FormControl>
                      </div>
                    </div>
                    <p className={styles.text}>
                      {stepLanguage.name_of_provider_line}
                    </p>
                    {item.hot_water_data.consumption_info.map(
                      (item1, index1) => {
                        const date = new Date(item1.date);

                        // Get the month (0-based index, so add 1 to get 1-based month)
                        const month = date.getMonth();

                        // Get the year
                        const year = date.getFullYear();
                        const consumptionErrorMessage =
                          errors[index]?.hot_water_data.consumption_info[
                            index1
                          ];
                        return (
                          <div className={styles.fieldCom} key={index1}>
                            <div
                              className={styles.fields}
                              style={{ width: "40%" }}
                            >
                              <p className={styles.fieldName}>
                                {stepLanguage.date}
                                <img
                                  src={info}
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handlePopUp(
                                      index1 == 0
                                        ? popData?.date
                                        : index1 == 1
                                        ? popData?.date2
                                        : index1 == 2
                                        ? popData?.date3
                                        : index1 == 3
                                        ? popData?.date4
                                        : ""
                                    )
                                  }
                                />
                              </p>
                              <DateField
                                onChange={(date) =>
                                  // setForm((prev) => ({ ...prev, Date: date }))
                                  handleDate(date, index, index1)
                                }
                                startDate={item1.date}
                                value={item1.date}
                                style={{ width: "90%" }}
                                key={index1}
                                disabled={true}
                              />
                            </div>
                            <div className={styles.fields}>
                              <p className={styles.fieldName}>
                                {stepLanguage.consumption_from_this}{" "}
                                {language === "de"
                                  ? germanMonths[month]
                                  : monthsdd[month]}{" "}
                                {year} {stepLanguage.to}{" "}
                                {language === "de"
                                  ? germanMonths[month - 1]
                                  : monthsdd[month - 1]}{" "}
                                {year + 1}
                                {/* date.getMonth() + 1 */}
                                <img
                                  src={info}
                                  style={{ cursor: "pointer" }}
                                  onClick={() =>
                                    handlePopUp(popData?.consumption)
                                  }
                                />
                              </p>
                              <TextField
                                size="small"
                                style={style}
                                onChange={(e) =>
                                  handleChange1(e, index, index1)
                                }
                                value={item1?.consumption}
                                // value={item1.consumption}
                                type="number"
                                InputProps={{
                                  endAdornment: (
                                    <InputAdornment position="end">
                                      {text}
                                    </InputAdornment>
                                  ),
                                }}
                                error={consumptionErrorMessage?.consumption}
                                helperText={
                                  consumptionErrorMessage?.consumption
                                }
                              />
                            </div>
                          </div>
                        );
                      }
                    )}
                  </div>
                )}
                {item.type === 3 && (
                  <div className={styles.fields}>
                    <p className={styles.fieldName}>
                      Energy Sources
                      <img src={info} />
                    </p>
                    <Select
                      style={style}
                      size="small"
                      onChange={(e) => handleChange(e, index)}
                      name="energy_source_id"
                    >
                      {energy.source.map((option) => (
                        <MenuItem key={option.id} value={option.id}>
                          {option.title}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                )}
              </div>
            );
          })}
          <div className={styles.hr} />
        </div>
      </div>
      <NavButton
        handleSubmit={handleSubmit}
        response={response}
        setResponse={setResponse}
        disabled={disableNext}
      />

      {pop && (
        <PopUpInfo
          handleClose={() => setPop(false)}
          open={pop}
          data={infoText}
        />
      )}
    </div>
  );
}

export default Step3;
const data1 = [{ id: 1 }, { id: 2 }];

const obj = {
  energy_source_id: 1,
  unit_id: 2,
  installation_year: 2008,
  index: 3,
  consumption_info: [
    {
      date: "2020-03-10",
      consumption: 300,
    },
    {
      date: "2021-03-10",
      consumption: 400,
    },
    {
      date: "2022-03-10",
      consumption: 550,
    },
  ],
};
const monthsdd = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const isAllFieldsEmpty = (errors) => {
  const checkIfEmpty = (value) => {
    if (typeof value === "string") {
      return value === ""; // Check if the string is empty
    }
    if (Array.isArray(value)) {
      if (value.length === 0) {
        return true; // Empty array is considered empty
      }

      // Check if consumption_info array has more than 1 object
      if (value.length > 0 && typeof value[0] === "object") {
        return value.every((obj) => {
          return (
            obj.hasOwnProperty("date") &&
            obj.hasOwnProperty("consumption") &&
            obj.date === "" &&
            obj.consumption === ""
          ); // Check if each object in the array has empty date and consumption fields
        });
      }

      return false; // Non-empty array is considered not empty
    }

    if (typeof value === "object" && value !== null) {
      // Recursively check nested objects
      return Object.keys(value).every((key) => checkIfEmpty(value[key]));
    }

    return false; // Other types are considered not empty
  };

  // Iterate through each error object
  return errors.every((errorObj) => {
    return Object.keys(errorObj).every((key) => {
      const value = errorObj[key];
      return checkIfEmpty(value); // Use recursive function to check each key
    });
  });
};
